import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.externalInstitutions',
    'package:data.higherEd.research.projects',
    'package:data.universal.commonStructures',
    'resource:data.dimensions.externalPersonnel.entities.employee.attributes.institution',
    'resource:data.dimensions.externalPersonnel.entities.employee.attributes.person',
    'resource:data.dimensions.externalPersonnel.entities.employee',
    'resource:data.dimensions.externalPersonnel',
    'resource:data.dimensions.subawardPis.entities.entry.attributes.pi',
    'resource:data.dimensions.subawardPis.entities.entry.attributes.subaward',
    'resource:data.dimensions.subawardPis.entities.entry',
    'resource:data.dimensions.subawardPis',
    'resource:data.dimensions.subawards.entities.subaward.attributes.administrativeAddress',
    'resource:data.dimensions.subawards.entities.subaward.attributes.administrativeContact',
    'resource:data.dimensions.subawards.entities.subaward.attributes.authorizedContact',
    'resource:data.dimensions.subawards.entities.subaward.attributes.budgetPeriod',
    'resource:data.dimensions.subawards.entities.subaward.attributes.currentAmount',
    'resource:data.dimensions.subawards.entities.subaward.attributes.financialContact',
    'resource:data.dimensions.subawards.entities.subaward.attributes.invoiceContact',
    'resource:data.dimensions.subawards.entities.subaward.attributes.isAmmendment',
    'resource:data.dimensions.subawards.entities.subaward.attributes.paymentAddress',
    'resource:data.dimensions.subawards.entities.subaward.attributes.performanceAddress',
    'resource:data.dimensions.subawards.entities.subaward.attributes.performancePeriod',
    'resource:data.dimensions.subawards.entities.subaward.attributes.project',
    'resource:data.dimensions.subawards.entities.subaward.attributes.subrecipient',
    'resource:data.dimensions.subawards.entities.subaward.attributes.subrecipientPi',
    'resource:data.dimensions.subawards.entities.subaward.attributes.totalAmount',
    'resource:data.dimensions.subawards.entities.subaward',
    'resource:data.dimensions.subawards',
    'resource:data.dimensions.subrecipients.entities.subrecipient.attributes.institution',
    'resource:data.dimensions.subrecipients.entities.subrecipient.attributes.primaryContact',
    'resource:data.dimensions.subrecipients.entities.subrecipient.attributes.website',
    'resource:data.dimensions.subrecipients.entities.subrecipient',
    'resource:data.dimensions.subrecipients.snapshots.subrecipientRiskSurvey',
    'resource:data.dimensions.subrecipients',
  ],
  description: 'TODO',
  name: 'Subrecipients',
} as const satisfies core.quiver.Package
